<template >
    <div>
        <div>
            <Header />
            <div>
                <div>
                    <div class="navTitle">
                        <span class="exhibitTitle" style="font-style: default;">{{ exhibitName }} : </span> 
                        <span @click="navigateToExhibits" style="font-style: italic;">Retourner aux expositions > </span><span @click="navigateToExpo_bu" style="font-style: italic;"> Créer la
                            page d'accueil > </span> <span style="font-style: italic;"> Choisir le type de création
                        </span>
                    </div>
                    <br />
                    <div class="navButtons">
                        <q-btn color="pink-10" style="margin-left: 7%" @click="navigateBack">Retour</q-btn>
                        <div>
                            <q-btn label="Prévisualiser l'exposition" color="blue-grey-4" @click="openNewTab" />
                        </div>
                        <div>
                            
                        </div>
                    </div>

                </div>

            </div>
            <hr style="margin-bottom: 15px" />

        </div>
        <ExpositionTemplateSetup />
    </div>
</template>
<script>
import Header from '../components/Header.vue';
import ExpositionTemplateSetup from '../components/ExpositionTemplateSetup.vue';
import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
export default {
    components: {
        Header,
        ExpositionTemplateSetup
    },
    setup() {
        let exhibitName = ref('');
        const store = useStore();
        const router = useRouter();

        const navigateBack = () => {
            router.go(-1);
        }

        const navigateToExpo_bu = () => {
            console.log("navigateToExpo_bu");
            router.push({ path: `/expo/${store.state.exhibitId}` });
        }

        const navigateToExhibits = () => {
            router.push("/admin")
        }

        const openNewTab = () => {
            window.open(store.getters.exhibitUrl, "_blank");
        }

        onMounted(() => {
            exhibitName.value = store.state.exhibitName;
        })
        return {
            exhibitName,
            navigateBack,
            navigateToExpo_bu,
            openNewTab,
            navigateToExhibits
        }
    }
}
</script>
<style >
.navButtons {
    display: flex;
    justify-content: space-between;
}
</style>